/* eslint-disable max-len */
import React, {
  useEffect,
  useRef,
} from 'react';

import PropTypes from 'prop-types';

import GlslCanvas from 'glslCanvas';

const GLSLCanvas = (props) => {

  const {
    frag,
    uniforms,
  } = props;

  const canvasRef = useRef(null);

  const glslRef = useRef();

  useEffect(() => {

    const canvas = canvasRef.current;

    let glsl = glslRef.current;
    if (!glsl) {
      glsl = new GlslCanvas(canvas);
      glslRef.current = glsl;
      /*
      // This was an attempt to slow down stumbling animations on slow-CPU Chromeboxes.
      // Decided it didn't really work that well
      if (props.refreshInterval) {
        // Default behavior is to hit requestAnimationFrame()
        glsl.pause(); // Shut off internal requestAnimationFrame mechanism
        const doRender = () => {
          // console.log('refreshInterval', props.refreshInterval);
          // console.log('now', Date.now());
          glsl.forceRender = true;
          glsl.render();
          glsl.pause();
          setTimeout(doRender, props.refreshInterval);
        };
        doRender();
      }
       */
    }
    glsl.load(frag);
    uniforms.forEach((u) => {
      let value = u.value;
      value = Array.isArray(value) ? value : [value];
      glsl.setUniform(u.name, ...value);
    });
  });

  return (
    <canvas
      className="glslCanvas"
      width={props.width}
      height={props.height}
      ref={canvasRef}
    />
  );

};

GLSLCanvas.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  frag: PropTypes.string,
  uniforms: PropTypes.arrayOf(PropTypes.object),
  // refreshInterval: PropTypes.number,
};

GLSLCanvas.defaultProps = {
  width: 300,
  height: 150,
  // frag: 'void main() {\n gl_FragColor = vec4(0.33, 0.33, 1.0, 1.0);\n }',
  frag: `
    precision mediump float;
    
    uniform float u_time;
    uniform vec2 u_mouse;
    uniform vec2 u_resolution;
    
    float SCALE = 40.0;
    float SPEED = 10.0;
    float SHADOW = 0.4; // Set to 1.0 for no shadow
    
    float norm(float u) {
      float fudge = 2.0;
      return ((u + 1.0) / 2.0) / fudge;
    }
    
    void main() {
    
      vec2 position = 2.0 * (0.5 - ( gl_FragCoord.xy / u_resolution.xy ));
      position.x *= (u_resolution.x / u_resolution.y);
      float x = position.x * SCALE;
      float y = position.y * SCALE;
      y = -y;
    
      float r = sqrt((x * x) + (y * y));
      float red =   ((x * cos(r - SPEED * u_time)) - (y * sin(r - SPEED * u_time ))) / r;
      float green = ((x * cos(r - SPEED * u_time - (2.0 * 3.14 / 3.0))) - (y * sin(r - SPEED * u_time - (SHADOW * 2.0 * 3.14 / 3.0) ))) / r;
      float blue =  ((x * cos(r - SPEED * u_time - (SHADOW * 4.0 * 3.14 / 3.0))) - (y * sin(r - SPEED * u_time - (4.0 * 3.14 / 3.0) ))) / r;
    
      red = norm(red);
      green = norm(green);
      blue = norm(blue);
    
      gl_FragColor = vec4( vec3(red, green, blue), 1.0);
    }
  `,
  uniforms: [],
  // refreshInterval: 0,
};

export default GLSLCanvas;
